import { render } from "./trumpetenterpriseAllocation.vue?vue&type=template&id=3dcf479a&scoped=true"
import script from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"
export * from "./trumpetenterpriseAllocation.vue?vue&type=script&lang=js"

import "./trumpetenterpriseAllocation.vue?vue&type=style&index=0&id=3dcf479a&scoped=true&lang=css"
import "./trumpetenterpriseAllocation.vue?vue&type=style&index=1&id=3dcf479a&lang=css"
script.render = render
script.__scopeId = "data-v-3dcf479a"

export default script